import { Component, OnInit, OnDestroy, Input } from '@angular/core';

import { Subscription, startWith, switchMap, merge, pairwise, filter, tap } from 'rxjs';

import { Export } from '@shared/export/models';
import { WebSocketEventsEnum } from '@shared/websocket';
import { ExportDataService } from '../../services/export-data.service';
import {
  AuthLocationService,
  AuthRestaurantService,
  SocketService,
} from '@tablesready/frontend-store';

@Component({
  selector: 'tablesready-export-history',
  templateUrl: './export-history.component.html',
})
export class ExportHistoryComponent implements OnInit, OnDestroy {
  @Input() timezone = '';
  @Input() hasBusinessPlanLocation = false;
  currentExports: Export[];

  private readonly subscriptions = new Subscription();

  constructor(
    private readonly socketService: SocketService,
    private readonly exportDataService: ExportDataService,
    private readonly locationService: AuthLocationService,
    private readonly authRestaurantService: AuthRestaurantService,
  ) {}

  ngOnInit(): void {
    const exportsSubscription = merge(
      this.socketService.getEventStream(WebSocketEventsEnum.exports),
      this.authRestaurantService.select().pipe(
        startWith(null),
        pairwise(),
        filter(([prev, current]) => prev?.account?.id !== current.account?.id && !!current.account),
      ),
    )
      .pipe(
        switchMap(() => this.exportDataService.getExports()),
        tap(exports => this.currentExports = exports),
      )
      .subscribe();
    this.subscriptions.add(exportsSubscription);
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  getLocationNameById(id: string | null): string {
    if (id) {
      return this.locationService.getById(id).name;
    }

    return 'All locations';
  }
}
